import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BenefitsItemModule } from '../benefits-item/benefits-item.module';
import { BenefitBoxModule } from '../benefit-box/benefit-box.module';
import { SliderModule } from '../slider/slider.module';

@NgModule({
  declarations: [],
  imports: [BenefitsItemModule, BenefitBoxModule, SliderModule, CommonModule],
})
export class PointsHistoricModule {}
